var elementTextFilter = {

	/**
	 * Init event listeners
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {

		if (target) {
			target.addEventListener('keyup', function() {
				var parentSelector = this.getAttribute('data-element-text-filter-parent-selector') || '[data-element-text-filter-parent]';
				var groupSelector = this.getAttribute('data-element-text-filter-group-selector') || '[data-element-text-filter-group]';
				var childSelector = this.getAttribute('data-element-text-filter-child-selector') || '[data-element-text-filter-list-item]';
				var termSelector = this.getAttribute('data-element-text-filter-term-selector') || '[data-element-text-filter-list-item-term]';
				var hideClass = this.getAttribute('data-element-text-filter-hide-class') || 'd-none';
				elementTextFilter.filter(target, parentSelector, childSelector, termSelector, hideClass, groupSelector);
			});
		}

	},

	/**
	 * Filter elelement children by string
	 *
	 * @param {Element} input
	 * @param {String} parentSelector
	 * @param {String} childSelector
	 * @param {String} termSelector
	 * @param {String} hideClass
	 *
	 * @return {void}
	 */
	filter: function(input, parentSelector, childSelector, termSelector, hideClass, groupSelector = null) {

		let filter = input.value.toUpperCase();
		let parent = document.querySelector(parentSelector);
		let children = parent.querySelectorAll(childSelector);

		children.forEach(child => {
			let termString = '';
			let termElements = child.querySelectorAll(termSelector);
			termElements.forEach(element => {
				termString = termString + ' ' + element.textContent;
			});
			child.classList.remove(hideClass);
			if (!(termString.toUpperCase().indexOf(filter) > -1)) {
				child.classList.add(hideClass);
			}
		});

		if (groupSelector !== null) {
			let groups = parent.querySelectorAll(groupSelector);
			groups.forEach(group => {
				group.classList.remove(hideClass);
				let visibleChildren = group.querySelectorAll('[data-element-text-filter-list-item]:not(.' + hideClass + ')');
				if (visibleChildren.length === 0) {
					group.classList.add(hideClass);
				}
			});
		}

	},

};

export default elementTextFilter;
